// TODO: Need deeper integration with ActionText and ActiveStorage

import Trix from 'trix'

// https://github.com/gorails-screencasts/trix-editor-and-file-uploads/blob/master/app/assets/javascripts/trix_uploads.js
Trix.config.attachments.preview.caption = {
  name: false,
  size: false
};

function uploadAttachment(attachment) {
  // Create our form data to submit
  var file = attachment.file;
  var form = new FormData;
  form.append("Content-Type", file.type);
  form.append("file[data]", file);

  // Create our XHR request
  var xhr = new XMLHttpRequest;
  xhr.open("POST", "/files", true);
  xhr.setRequestHeader("X-CSRF-Token", Rails.csrfToken());

  // Report file uploads back to Trix
  xhr.upload.onprogress = function(event) {
    var progress = event.loaded / event.total * 100;
    attachment.setUploadProgress(progress);
  }

  // Tell Trix what url and href to use on successful upload
  xhr.onload = function() {
    if (xhr.status === 201) {
      var data = JSON.parse(xhr.responseText);
      return attachment.setAttributes({
        url: data.image_url,
        href: data.url,
        blob_id: data.id
      })
    } else {
      attachment.remove();
    }
  }

  return xhr.send(form);
}

// Listen for the Trix attachment event to trigger upload
document.addEventListener("trix-attachment-add", function(event) {
  var attachment = event.attachment;
  if (attachment.file) {
    console.log("Uploading attachment");
    return uploadAttachment(attachment);
  }
});